import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הקול (בלי להזדהות איתו)",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק/ה לקרוא לזה “אני”. זה קול. והוא אכזרי."
    ],
      [
      "היום אני מפסיק/ה לקרוא לזה “אני”. זה קול. והוא אכזרי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת איטית.",
      "בלב: “זה קול פנימי — לא אמת מוחלטת.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת איטית.",
      "בלב: “זה קול פנימי — לא אמת מוחלטת.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזה משפט אכזרי חזר לי היום?\n[כאן אני כותב]",
      "2. באיזה טון הוא נאמר? (כועס / מזלזל / משפיל)\n[כאן אני כותב]",
      "3. מתי הקול הזה הכי חזק?\n[כאן אני כותב]"
    ],
      [
      "1. איזה משפט אכזרי חזר לי היום?\n[כאן אני כותב]",
      "2. באיזה טון הוא נאמר? (כועס / מזלזל / משפיל)\n[כאן אני כותב]",
      "3. מתי הקול הזה הכי חזק?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לזהות קול — זה כבר צעד ראשון לחופש."
    ],
      [
      "סגירה",
      "לזהות קול — זה כבר צעד ראשון לחופש."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: “זה הקול המבקר. לא אני.”",
      "פעם אחת היום: “זה הקול המבקר. לא אני.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה הקול מנסה לעשות בשבילי",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת: גם ביקורת אכזרית מנסה להגן."
    ],
      [
      "היום אני בודק/ת: גם ביקורת אכזרית מנסה להגן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה הקול אומר לי שיקרה אם לא אהיה קשה עם עצמי?\n[כאן אני כותב]",
      "2. ממה הוא מנסה להגן עליי? (כישלון / דחייה / בושה)\n[כאן אני כותב]",
      "3. איזו דרך פחות אלימה יכולה להגן עליי?\n[כאן אני כותב]"
    ],
      [
      "1. מה הקול אומר לי שיקרה אם לא אהיה קשה עם עצמי?\n[כאן אני כותב]",
      "2. ממה הוא מנסה להגן עליי? (כישלון / דחייה / בושה)\n[כאן אני כותב]",
      "3. איזו דרך פחות אלימה יכולה להגן עליי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הכוונה אולי הגנה — הדרך פוגעת."
    ],
      [
      "סגירה",
      "הכוונה אולי הגנה — הדרך פוגעת."
    ]
    ),
    action: localizedGenderNode(
      "אני אומר/ת: “אני מבין/ה את הפחד. לא את האלימות.”",
      "אני אומר/ת: “אני מבין/ה את הפחד. לא את האלימות.”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "ההבדל בין אחריות להלקאה",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין ללמוד — לבין לשבור את עצמי."
    ],
      [
      "היום אני מפריד/ה בין ללמוד — לבין לשבור את עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. על מה אני מאשים/ה את עצמי שוב ושוב?\n[כאן אני כותב]",
      "2. מה חלק קטן שכן באחריות שלי?\n[כאן אני כותב]",
      "3. איך נשמעת אחריות בלי השפלה?\n[כאן אני כותב]"
    ],
      [
      "1. על מה אני מאשים/ה את עצמי שוב ושוב?\n[כאן אני כותב]",
      "2. מה חלק קטן שכן באחריות שלי?\n[כאן אני כותב]",
      "3. איך נשמעת אחריות בלי השפלה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אחריות בונה. הלקאה הורסת."
    ],
      [
      "סגירה",
      "אחריות בונה. הלקאה הורסת."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה האשמה — אני מחפש/ת ניסוח בלי עלבון.",
      "כשעולה האשמה — אני מחפש/ת ניסוח בלי עלבון."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "השוואה כביקורת עצמית סמויה",
    opening: localizedGenderNode(
      [
      "היום אני רואה איך השוואה הופכת לביקורת."
    ],
      [
      "היום אני רואה איך השוואה הופכת לביקורת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. למי אני משווה את עצמי כשאני שופט/ת?\n[כאן אני כותב]",
      "2. מה תמיד חסר לי בהשוואה הזאת?\n[כאן אני כותב]",
      "3. איזו אמת עליי לא נכנסת להשוואה?\n[כאן אני כותב]"
    ],
      [
      "1. למי אני משווה את עצמי כשאני שופט/ת?\n[כאן אני כותב]",
      "2. מה תמיד חסר לי בהשוואה הזאת?\n[כאן אני כותב]",
      "3. איזו אמת עליי לא נכנסת להשוואה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "השוואה לא משקפת אמת — היא מחדדת כאב."
    ],
      [
      "סגירה",
      "השוואה לא משקפת אמת — היא מחדדת כאב."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: “אני יוצא/ת מההשוואה.”",
      "פעם אחת היום: “אני יוצא/ת מההשוואה.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הבושה שמתחת לביקורת",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בבושה — בלי לברוח."
    ],
      [
      "היום אני נוגע/ת בבושה — בלי לברוח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. על מה אני מתבייש/ת בעצמי?\n[כאן אני כותב]",
      "2. מה אני מפחד/ת שיראו בי?\n[כאן אני כותב]",
      "3. איזו אנושיות יש במקום הזה?\n[כאן אני כותב]"
    ],
      [
      "1. על מה אני מתבייש/ת בעצמי?\n[כאן אני כותב]",
      "2. מה אני מפחד/ת שיראו בי?\n[כאן אני כותב]",
      "3. איזו אנושיות יש במקום הזה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בושה היא סימן לפצע — לא לפגם."
    ],
      [
      "סגירה",
      "בושה היא סימן לפצע — לא לפגם."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד של אנושיות לעצמי.",
      "משפט אחד של אנושיות לעצמי."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "איך אני מדבר/ת לעצמי כשאני טועה",
    opening: localizedGenderNode(
      [
      "היום אני שם לב לשפה שלי ברגע טעות."
    ],
      [
      "היום אני שם לב לשפה שלי ברגע טעות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה אני אומר/ת לעצמי כשאני טועה?\n[כאן אני כותב]",
      "2. איך זה משפיע על הגוף שלי?\n[כאן אני כותב]",
      "3. איך הייתי מדבר/ת לילד/ה במצב דומה?\n[כאן אני כותב]"
    ],
      [
      "1. מה אני אומר/ת לעצמי כשאני טועה?\n[כאן אני כותב]",
      "2. איך זה משפיע על הגוף שלי?\n[כאן אני כותב]",
      "3. איך הייתי מדבר/ת לילד/ה במצב דומה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "טעות לא דורשת אלימות."
    ],
      [
      "סגירה",
      "טעות לא דורשת אלימות."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת משפט תיקון במקום השפלה.",
      "אני בוחר/ת משפט תיקון במקום השפלה."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "ניסוי: יום בלי שיפוט",
    opening: localizedGenderNode(
      [
      "היום אני מתאני בודק/ת בעדינות בהפחתת שיפוט — לא בהיעלמותו."
    ],
      [
      "היום אני מתאני בודק/ת בעדינות בהפחתת שיפוט — לא בהיעלמותו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. באיזה רגעים השיפוט קופץ הכי מהר?\n[כאן אני כותב]",
      "2. איזה ניסוח רך יכול להחליף אותו?\n[כאן אני כותב]",
      "3. מה אני רוצה לבדוק היום?\n[כאן אני כותב]"
    ],
      [
      "1. באיזה רגעים השיפוט קופץ הכי מהר?\n[כאן אני כותב]",
      "2. איזה ניסוח רך יכול להחליף אותו?\n[כאן אני כותב]",
      "3. מה אני רוצה לבדוק היום?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "זה ניסוי. לא מבחן."
    ],
      [
      "סגירה",
      "זה ניסוי. לא מבחן."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום — ניסוח רך במקום אכזרי.",
      "פעם אחת היום — ניסוח רך במקום אכזרי."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "לשאת אי־שלמות (ACT)",
    opening: localizedGenderNode(
      [
      "היום אני מאפשר/ת לעצמי להיות לא מושלם/ת — דקה אחת."
    ],
      [
      "היום אני מאפשר/ת לעצמי להיות לא מושלם/ת — דקה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזו אי־שלמות הכי מפעילה בי ביקורת?\n[כאן אני כותב]",
      "2. דקה אחת: אני נותן/ת לזה להיות כאן.\nמה קרה?\n[כאן אני כותב]",
      "3. מה למדתי על התחושה?\n[כאן אני כותב]"
    ],
      [
      "1. איזו אי־שלמות הכי מפעילה בי ביקורת?\n[כאן אני כותב]",
      "2. דקה אחת: אני נותן/ת לזה להיות כאן.\nמה קרה?\n[כאן אני כותב]",
      "3. מה למדתי על התחושה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אי־שלמות לא הורגת אותי."
    ],
      [
      "סגירה",
      "אי־שלמות לא הורגת אותי."
    ]
    ),
    action: localizedGenderNode(
      "דקה אחת בלבד. זה מספיק.",
      "דקה אחת בלבד. זה מספיק."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "מי הייתי בלי הקול הזה",
    opening: localizedGenderNode(
      [
      "היום אני זוכר/ת מי אני בלי הביקורת."
    ],
      [
      "היום אני זוכר/ת מי אני בלי הביקורת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איך הייתי לפני שהקול נהיה דומיננטי?\n[כאן אני כותב]",
      "2. איזה חלק בי נעלם עם השנים?\n[כאן אני כותב]",
      "3. מה אני מתגעגע/ת בו?\n[כאן אני כותב]"
    ],
      [
      "1. איך הייתי לפני שהקול נהיה דומיננטי?\n[כאן אני כותב]",
      "2. איזה חלק בי נעלם עם השנים?\n[כאן אני כותב]",
      "3. מה אני מתגעגע/ת בו?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא הקול. אני האדם שמתחתיו."
    ],
      [
      "סגירה",
      "אני לא הקול. אני האדם שמתחתיו."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמחברת אותי לעצמי האמיתי/ת.",
      "פעולה אחת שמחברת אותי לעצמי האמיתי/ת."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "חמלה בלי לוותר על צמיחה",
    opening: localizedGenderNode(
      [
      "היום אני מבין/ה שחמלה לא מבטלת שינוי."
    ],
      [
      "היום אני מבין/ה שחמלה לא מבטלת שינוי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ממה אני מפחד/ת אם אהיה רך/ה עם עצמי?\n[כאן אני כותב]",
      "2. איזו צמיחה כן אפשרית עם חמלה?\n[כאן אני כותב]",
      "3. איזה משפט רך מותר לי לאמץ?\n[כאן אני כותב]"
    ],
      [
      "1. ממה אני מפחד/ת אם אהיה רך/ה עם עצמי?\n[כאן אני כותב]",
      "2. איזו צמיחה כן אפשרית עם חמלה?\n[כאן אני כותב]",
      "3. איזה משפט רך מותר לי לאמץ?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "חמלה היא קרקע לצמיחה."
    ],
      [
      "סגירה",
      "חמלה היא קרקע לצמיחה."
    ]
    ),
    action: localizedGenderNode(
      "יד על הגוף + המשפט הרך.",
      "יד על הגוף + המשפט הרך."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "גבול מול הקול המבקר",
    opening: localizedGenderNode(
      [
      "היום אני שם גבול פנימי."
    ],
      [
      "היום אני שם גבול פנימי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזה משפט של הקול אני כבר לא מוכן/ה לשמוע?\n[כאן אני כותב]",
      "2. איך נשמע גבול פנימי?\n[כאן אני כותב]",
      "3. מה הפחד אם אשים גבול?\n[כאן אני כותב]"
    ],
      [
      "1. איזה משפט של הקול אני כבר לא מוכן/ה לשמוע?\n[כאן אני כותב]",
      "2. איך נשמע גבול פנימי?\n[כאן אני כותב]",
      "3. מה הפחד אם אשים גבול?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "גם לקולות פנימיים יש גבולות."
    ],
      [
      "סגירה",
      "גם לקולות פנימיים יש גבולות."
    ]
    ),
    action: localizedGenderNode(
      "אני עוצר/ת משפט אחד באמצע.",
      "אני עוצר/ת משפט אחד באמצע."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "לתקן את הטון, לא את הסיפור",
    opening: localizedGenderNode(
      [
      "היום אני משנה טון — לא מוחק עבר."
    ],
      [
      "היום אני משנה טון — לא מוחק עבר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזה סיפור אני מספר/ת לעצמי?\n[כאן אני כותב]",
      "2. איך אותו סיפור נשמע בטון אנושי?\n[כאן אני כותב]",
      "3. איזה טון אני בוחר/ת השבוע?\n[כאן אני כותב]"
    ],
      [
      "1. איזה סיפור אני מספר/ת לעצמי?\n[כאן אני כותב]",
      "2. איך אותו סיפור נשמע בטון אנושי?\n[כאן אני כותב]",
      "3. איזה טון אני בוחר/ת השבוע?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הטון קובע את החוויה."
    ],
      [
      "סגירה",
      "הטון קובע את החוויה."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום — שינוי טון בלבד.",
      "פעם אחת היום — שינוי טון בלבד."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "לבחור קול מוביל חדש",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת איזה קול מוביל אותי."
    ],
      [
      "היום אני בוחר/ת איזה קול מוביל אותי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזה ערך אני רוצה שקולי יבטא? (כבוד / אמת / רוך)\n[כאן אני כותב]",
      "2. איך נשמע הקול הזה?\n[כאן אני כותב]",
      "3. מה אני מבטיח/ה לעצמי ביום קשה?\n[כאן אני כותב]"
    ],
      [
      "1. איזה ערך אני רוצה שקולי יבטא? (כבוד / אמת / רוך)\n[כאן אני כותב]",
      "2. איך נשמע הקול הזה?\n[כאן אני כותב]",
      "3. מה אני מבטיח/ה לעצמי ביום קשה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא משתיק/ה קול — אני מחליף/ה הנהגה."
    ],
      [
      "סגירה",
      "אני לא משתיק/ה קול — אני מחליף/ה הנהגה."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת משפט הנהגה ושומר/ת.",
      "אני כותב/ת משפט הנהגה ושומר/ת."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת מסע — לא מלחמה."
    ],
      [
      "היום אני מסיים/ת מסע — לא מלחמה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה השתנה בי ביחס לביקורת?\n[כאן אני כותב]",
      "2. מה אני מבין/ה עכשיו על עצמי?\n[כאן אני כותב]",
      "3. משפט חזרה לימים קשים:\n[כאן אני כותב]"
    ],
      [
      "1. מה השתנה בי ביחס לביקורת?\n[כאן אני כותב]",
      "2. מה אני מבין/ה עכשיו על עצמי?\n[כאן אני כותב]",
      "3. משפט חזרה לימים קשים:\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית",
      "אני עדיין לומד/ת.",
      "אבל אני כבר לא נגד עצמי.",
      "וזה שינוי עמוק."
    ],
      [
      "סגירה סופית",
      "אני עדיין לומד/ת.",
      "אבל אני כבר לא נגד עצמי.",
      "וזה שינוי עמוק."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמסמלת בחירה בי.",
      "פעולה אחת שמסמלת בחירה בי."
    ),
  },
].map(buildNormalizedDay);

export const harshSelfCriticismBlueprintHe = buildNormalizedPilotBlueprint({
  id: "harsh_self_criticism_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "harsh_self_criticism",
  category: "general",
  journeyName: {
    he: "שיפוט עצמי אכזרי / ביקורת עצמית אכזרית",
    en: "Harsh Self-Judgment / Cruel Self-Criticism",
    es: "Juicio Interno Cruel / Crítica Interior Severa",
  },
  days,
});

export default harshSelfCriticismBlueprintHe;
